module.exports = new __parcel__URL__("recruitment_zh-tw.98723dc9.webp").toString();